const state = {
    menuPath:'',
}
const mutations = {
    setMenuPath(state, model) {
        state.menuPath = model
    },
}
const actions = {

}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
};